__webpack_require__.p = "https://pos.labiferia.com.mx/";